import { useMutation } from '@tanstack/react-query'

import { fetchWithHeaders } from 'utils'

type UpdatePayrollProviderConfigParams = {
  id: string;
  enabled?: boolean;
  promoted_in_onboarding?: boolean;
  supports_automatic_deductions?: boolean
}

export function useUpdatePayrollProviderConfig () {
  return useMutation({
    mutationFn: async (params: UpdatePayrollProviderConfigParams) => {
      const response = await fetchWithHeaders(`/api/web/admin/payroll_provider_configs/${params.id}`, {
        method: 'PUT',
        body: JSON.stringify(params),
      })

      if (!response.ok) {
        const error = await response.json()
        throw new Error(error.message || 'Failed to update payroll provider config')
      }

      return response.json()
    }
  })
}
